import React from 'react';
import { Select, Zoom } from '@mui/material';

// temp component to override transition component to avoid issue due to safari CSS bug
// https://github.com/mui/material-ui/pull/32202
const TempSelect = props => {
  const { MenuProps, ...rest } = props;

  return (
    <Select
      variant="standard"
      MenuProps={{
        TransitionComponent: Zoom,
        ...MenuProps
      }}
      {...rest}
    />
  );
};

export default TempSelect;
